import React from 'react';
import './CampaignCreationWrapper.scss';

export const CampaignCreationWrapper: React.FC = ({ children }) => {
  return <div className="CampaignCreationWrapper">{children}</div>;
};
